import React, { useState, useEffect, useRef, Fragment } from "react";
import { useStore, useDispatch, useSelector } from 'react-redux'
// reactstrap components
import {
  Button,
  Card,
  CardText,
  CardTitle,
  CardImg,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";



// core components
import LandingNavbar from "../../components/Navbars/LandingNavbar.js";
import TransparentFooter from "../../components/Footers/TransparentFooter.js";
import ReactDatatable from "@ashvin27/react-datatable";
import { login, getUserProfile} from "../../actions"
import swal from 'sweetalert'
import { getRoomAll } from "actions/userAction";


function CounsellingRoomPage(props) {
  const dispatch = useDispatch()
  
  const [token, setToken] = useState(localStorage.getItem("access-token"))
  const [counsellingRoom, setCounsellingRoom] = useState([]);

  const {
    userGetRooms: rooms
  } = useSelector((state) => state);

  const [time, setTime] = useState(null);

  useEffect(() => {
    let time = getHoursCurrentTime();
    setTime(time);
  }, []);
  
  const getHoursCurrentTime = () => {
    let today = new Date();
    let hours = (today.getHours() < 10 ? '0' : '') + today.getHours();
    let minutes = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
    let seconds = (today.getSeconds() < 10 ? '0' : '') + today.getSeconds();
    return hours + ':' + minutes + ':' + seconds;
  }

  useEffect(() => {
    if(rooms.data && !rooms.isLoading && !rooms.isFailed){
      setCounsellingRoom(rooms.data)
    }
  }, [rooms])

  useEffect(() => {
    dispatch(getRoomAll())
    document.body.classList.add("counselling-room-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("counselling-room-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      console.log('load rooms')
      dispatch(getRoomAll())
    }, 5*60000);
    //load interval 5 min
    return () => clearInterval(interval);
  }, []);

  const [usersConfig, setUsersConfig] = useState({
    key_column: "telephoneNo",
    page_size: 100,
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: false,
    show_info: false,
  });
  const [usersButtons, setUsersButtons] = useState([
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ]);
  const [roomColumn, setroomColumn] = useState([
    {
      key: "room_name",
      text: "ชื่อห้อง",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return  ( 
          <Fragment>
             
                {record.room_name}
             
          </Fragment>)
      },
    },
    {
      key: "counsellor_full_name",
      text: "ผู้ให้บริการ",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return  ( 
          <Fragment>
             
                {record.counsellor_full_name}
            
          </Fragment>)
      },
    },
    {
      key: "room_enter",
      text: "เข้าห้องให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return  ( 
          <Fragment>
            {record.is_open &&
              <Button
                className="btn-round"
                color="info"
                href={`https://meet.jit.si/${record.room_code}`}
                target="_blank"
              >
                เข้าห้อง
              </Button>}
            {!record.is_open && 'ไม่เปิดให้บริการในขณะนี้'}
          </Fragment>)
      },
    },
  ]);


  return (
    <>
      <LandingNavbar  />
      <div className="page-header clear-filter" filter-color="blue">
          <Container>
            <Col className="ml-auto mr-auto" md="8">
              <Card className="card-plain">
               
                  <CardHeader className="text-center">
                 
                  </CardHeader>
                  <CardBody>

                     <Button
                        block
                        className="btn-round"
                        color="info"
                       
                        size="lg"
                      >
                        ห้องให้บริการปรึกษา
                      </Button>
                     
                      <span>ให้บริการทุกวันจันทร์ ถึง วันศุกร์ เวลา 09:00 - 16:00 น. (หยุดให้บริการวันนักขัตฤกษ์)</span>
                     <br />
                      <ReactDatatable
                        config={usersConfig}
                        records={counsellingRoom}
                        columns={roomColumn}
                        usersButtons={usersButtons}
                        loading={rooms.isLoading}
                        page_size={100}
                       
                      />
                  </CardBody>
                  <CardFooter className="text-center">
                   
                    
                    หากต้องการใช้บริการนอกเหนือเวลาทำการ สามารถติดต่องานแนะแนวให้คำปรึกษา กองกิจการนิสิต มมส
                    โทร. 085-0100043, 085-0104544 (ให้บริการตลอด 24 ชั่วโมง)
                    เหมาะกับผู้ที่มีปัญหาความเครียดทั่วไป เช่น การเรียน การใช้ชีวิต
                    <br /><br />
                    ผู้ที่มีปัญหาความเครียดเฉียบพลัน มีความคิดอยากทำร้ายตัวเอง ต้องการคำปรึกษาแบบทันที โทร. 1323 สายด่วน สุขภาพจิต ของกรมสุขภาพจิต กระทรวงสาธารณสุข 
 (ให้บริการตลอด 24 ชั่วโมง)
                  </CardFooter>
                
              </Card>
            </Col>
          </Container>
        
        <TransparentFooter />

      </div>
    </>
  );
}

export default CounsellingRoomPage;
